import { Apps } from '../enums/enums';

export class LoginModel {
  email: string = '';
  password: string = '';
  userId: number = 0;
  fullName: string = '';
  msg: string = '';
  userRole: string = '';
  companyID: number = 0;
  company: string = '';
  userName: string = '';
  token: string = '';
  storeID: number = 0;
  ipAddress: string = '';
  accessRoleID: number = 0;
  productionAutoPrint: boolean = true;
  productionStayScreen: boolean = true;
  printPreview: boolean = false;
  isEnableSubcategory: boolean = false;
  isOPtionLock: boolean = false;
  isHidePricing: boolean = false;
  productionCycleColor: string = '';
  productionCycle: string = '';
  isNewUser: boolean = false;
  displayName: string = '';
  profileImgUrl: string = '';
  appID: number = 0;
  isActive: boolean = true;
  defaultModuleID: number = 0;
  outletID: number = 0;

  getLoginPayload() {
    return {
      userName: this.email,
      password: this.password,
    };
  }
}

export class Signout {
  userId: any;
  sessionId: any;
}

export interface LoginPayload {
  userName: string;
  password: string;
}

export class ProductImageResponse {
  id: number = 0;
  productId: number = 0;
  isPrimary: boolean = false;
  blobFileId: number = 0;
  url: string = '';
}

export class ConfirmEmail {
  token: string = '';
  email: string = '';
}

export class UserPermissions {
  id: number = 0;
  name: string = '';
  appId: number = 0;
  permissions: Array<Permission> = [];
}

export class Permission {
  id: number = 0;
  name: string = '';
}

export interface CreateUserPasscodeModel {
  companyId: number;
  userId: number;
  name: string;
  passcode: string;
  expiresAt: string | null;
  permissionIds: number[];
}

export interface UserPasscodeResponse {
  id: number;
  companyId: number;
  userId: number;
  name: string;
  passcode: string;
  expiresAt: string | null;
  permissionIds: number[];
  status?: number;
  isActive?: boolean;
}

export interface UserPasscodeListResponse {
  items: UserPasscodeResponse[];
}
interface AppVersionInfo {
  version: string;
  lastUpdated: string;
  url: string;
}

export class UserDetails {
  companyid: string = '0';
  email: string = '';
  exp: number = 0;
  fullname: string = '';
  iat: number = 0;
  iss: string = '';
  mustchangepasswordonlogin: string = '';
  nbf: number = 0;
  phonenumber: string = '';
  role: string = '';
  sub: string = '0';
  userid: string = '0';
}
export class AppDropdownModel {
  id: number = 0;
  name: string = '';
  storeAppId?: number = 0;
}
export class LookupModel {
  name: string = '';
  items: LookupItemsModel[] = [];
}
export class LookupItemsModel {
  id: number = 0;
  name: string = '';
}
export class CompanyModel {
  id: number = 0;
  name: string = '';
  status: number = 0;
  code: string = '';
  email: string = '';
  phoneNumber: string = '';
  website: string = '';
  logoUrl: string = '';
  businessTypeId: number = 0;
  teamSizeId: number = 0;
  currency: string = '';
  userTimeoutInMin: number = 0;
  showPrintPreview: boolean = false;
  inProduction: boolean = false;
  isMultipleStore: boolean = false;
  isBypassLicenses: boolean = false;
  isEnableSubcategory: boolean = false;
  primaryContact: PrimaryContact = new PrimaryContact();
  address: Address = new Address();
}
export class PrimaryContact {
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phoneNumber: string = '';
}
export class Address {
  line1: string = '';
  line2: string = '';
  city: string = '';
  zipCode: string = '';
  stateName: string = '';
  countryName: string = '';
  latitude: number = 0;
  longitude: number = 0;
  type: number = 0;
}
export class CountryModel {
  id: number = 0;
  name: string = '';
  fullName: string = '';
  code: string = '';
  currency: string = '';
  currencySymbol: string = '';
  continent: string = '';
  flagUrl: string = '';
}

export class StateModel {
  id: number = 0;
  name: string = '';
  code: string = '';
}

export class CompanyAppsModel {
  id: number = 0;
  apps: {
    id: number;
    name: string;
    roles: any[];
  }[] = [];
}

export class TimezoneModel {
  id: number = 0;
  name: string = '';
  abbreviation: string = '';
  code: string = '';
  standardUtcOffsetHours: number = 0;
  daylightUtcOffsetHours: number = 0;
  observesDaylightSaving: boolean = true;
  countryId: number = 0;
}
export class NamedResponse {
  id: number = 0;
  name: string = '';
}
export class WarehouseLocationLiteResponse {
  id: number = 0;
  name: string = '';
  warehouse: NamedResponse = {
    id: 0,
    name: '',
  };
}
export class CompanyApps {
  id: number = 0;
  apps: NamedResponse[] = [];
}
export class RumSettings {
  companyId: number = 0;
  enableRumForTpmApp: boolean = false;
  enableRumForPosApp: boolean = false;
  enableRumForListerApp: boolean = false;
  enableRumForCompanyApp: boolean = false;
  id: number = 0;
}

export enum BulkUploadEntityType {
  Department = 1,
  Category = 2,
}

export enum BulkUploadStatus {
  Success = 0,
  Failed = 1,
}

export interface BulkUploadIconItemResult {
  rowNumber: number;
  entityName: string;
  iconFileName: string;
  status: BulkUploadStatus;
  errorMessage?: string;
  blobFileId?: number;
}

export interface BulkUploadIconsResponse {
  entityType: string;
  totalRows: number;
  processedRows: number;
  successfulRows: number;
  failedRows: number;
  items: BulkUploadIconItemResult[];
}

// Shared Status enum for entities across admin and company portals
export enum Status {
  Unknown = 0,
  Draft = 1,
  Active = 2,
  Inactive = 3,
}

export const StatusLabels: Record<Status, string> = {
  [Status.Unknown]: 'Unknown',
  [Status.Draft]: 'Draft',
  [Status.Active]: 'Active',
  [Status.Inactive]: 'Inactive',
};

export const AppLabels: Record<Apps, string> = {
  [Apps.Unknown]: 'Unknown',
  [Apps.TPM]: 'TPM',
  [Apps.POS]: 'POS',
  [Apps.Donation]: 'Donation',
  [Apps.Lister]: 'Lister',
  [Apps.AdminPortal]: 'Admin Portal',
  [Apps.CompanyPortal]: 'Company Portal',
  [Apps.Inventory]: 'Inventory',
  [Apps.Consignment]: 'Consignment',
};

export const AppLogos: Partial<Record<Apps, string>> = {
  [Apps.TPM]: '/assets/images/subscription/TPMLogo.png',
  [Apps.POS]: '/assets/images/subscription/POSLogo.png',
  [Apps.Donation]: '/assets/images/users-management/donationlogo.svg',
  [Apps.Lister]: '/assets/images/subscription/ListerLogo.png',
};

export function getAppLogo(appId: number | null): string | null {
  if (!appId) return null;
  return AppLogos[appId as Apps] ?? null;
}

export function normalizeAppName(appId: number, rawName: string): string {
  return AppLabels[appId as Apps] ?? rawName;
}

export function ensureAppPresent(apps: NamedResponse[], appId: Apps): NamedResponse[] {
  if (apps.some((app) => app.id === appId)) {
    return apps;
  }
  return [...apps, { id: appId, name: AppLabels[appId] }];
}

export function mapAppIdsToNamedResponse<
  T extends { appId: number },
  E extends Record<string, any> = Record<string, never>,
>(
  appRecords: T[],
  sourceApps: NamedResponse[],
  extraProps?: (record: T) => E,
): (NamedResponse & E)[] {
  return appRecords.reduce<(NamedResponse & E)[]>((acc, record) => {
    const match = sourceApps.find((a) => a.id === record.appId);
    if (!match) return acc;
    acc.push({
      id: record.appId,
      name: normalizeAppName(match.id, match.name),
      ...(extraProps ? extraProps(record) : ({} as E)),
    });
    return acc;
  }, []);
}

